import "./error.scss";

const Error = () => (
    <div className = "error-request" data-test-id = "error">
        Ошибка получения данных
    </div>
);

export default Error;